(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDeleteController',PurchaseItemLotDeleteController);

    PurchaseItemLotDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchaseItemLot'];

    function PurchaseItemLotDeleteController($uibModalInstance, entity, PurchaseItemLot) {
        var vm = this;
        vm.purchaseItemLot = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchaseItemLot.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
